<template>
  <img v-if="screenshotUrl" :src="screenshotUrl" class="w-100" :alt="`Screenshot for ${url}`" />
</template>

<script>
// import Vue from "vue";
// import VueLazyload from 'vue-lazyload';
import sha1 from 'sha1';

// const placeholderImage = process.env.VUE_APP_THEME_PLACEHOLDER_IMAGE_URL;
// const placeholderImage = process.env.VUE_APP_PLUGIN_PLACEHOLDER_IMAGE_URL;
// const placeholderImage = '/img/no-screenshot.svg';
// Vue.use(VueLazyload, {
//   preLoad: 1.3,
//   error: placeholderImage,
//   loading: placeholderImage,
//   attempt: 1
// });

export default {
  name: 'InitialScreenshot',
  props: {
    url: {
      type: String,
      default: '',
    },
  },
  computed: {
    screenshotUrl() {
      return `${process.env.VUE_APP_S3_PUBLIC_URL}/get-started/${sha1(this.url)}.jpg`;
    },
  },
};
</script>
